import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

export function formatApiError(err) {
  const detail = err?.response?.data?.detail;
  if (detail == null) return err?.message || "Something went wrong.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

// Public
export const subscribeNewsletter = (email) => api.post("/newsletter", { email }).then((r) => r.data);
export const submitContact = (payload) => api.post("/contact", payload).then((r) => r.data);
export const getTournaments = () => api.get("/tournaments").then((r) => r.data);
export const getNews = () => api.get("/news").then((r) => r.data);
export const getTournamentBracket = (id) => api.get(`/tournaments/${id}/bracket`).then((r) => r.data);
export const getTournamentTeams = (id) => api.get(`/tournaments/${id}/teams`).then((r) => r.data);
export const getUserPublic = (id) => api.get(`/users/${id}`).then((r) => r.data);

// Auth
export const authRegister = (payload) => api.post("/auth/register", payload).then((r) => r.data);
export const authLogin = (payload) => api.post("/auth/login", payload).then((r) => r.data);
export const authGoogleCallback = (session_id) => api.post("/auth/google-callback", { session_id }).then((r) => r.data);
export const authLogout = () => api.post("/auth/logout").then((r) => r.data);
export const authMe = () => api.get("/auth/me").then((r) => r.data);
export const updateProfile = (payload) => api.patch("/auth/me", payload).then((r) => r.data);

// Teams
export const listTeams = () => api.get("/teams").then((r) => r.data);
export const getTeam = (id) => api.get(`/teams/${id}`).then((r) => r.data);
export const createTeam = (payload) => api.post("/teams", payload).then((r) => r.data);
export const inviteToTeam = (id, payload) => api.post(`/teams/${id}/invite`, payload).then((r) => r.data);
export const myInvites = () => api.get("/teams/invites/mine").then((r) => r.data);
export const acceptInvite = (id) => api.post(`/teams/invites/${id}/accept`).then((r) => r.data);
export const declineInvite = (id) => api.post(`/teams/invites/${id}/decline`).then((r) => r.data);
export const leaveTeam = (id) => api.post(`/teams/${id}/leave`).then((r) => r.data);
export const registerTeamForTournament = (id, payload) =>
  api.post(`/tournaments/${id}/register`, payload).then((r) => r.data);

// Notifications
export const listNotifications = () => api.get("/notifications").then((r) => r.data);
export const markNotificationRead = (id) => api.post(`/notifications/${id}/read`).then((r) => r.data);
export const markAllNotificationsRead = () => api.post("/notifications/read-all").then((r) => r.data);

// Admin
export const adminListTournaments = () => api.get("/admin/tournaments").then((r) => r.data);
export const adminUpdateTournament = (id, payload) =>
  api.patch(`/admin/tournaments/${id}`, payload).then((r) => r.data);
export const adminGenerateBracket = (id) =>
  api.post(`/admin/tournaments/${id}/bracket/generate`, {}).then((r) => r.data);
export const adminUpdateMatch = (matchId, payload) =>
  api.patch(`/admin/matches/${matchId}`, payload).then((r) => r.data);
export const adminNotify = (payload) => api.post("/admin/notify", payload).then((r) => r.data);
